// extracted by mini-css-extract-plugin
module.exports = {"taskWrap":"MilestoneTask_taskWrap__rgmF3","taskContent":"MilestoneTask_taskContent__wK3o4","completed":"MilestoneTask_completed__3KuMd"};